<div class="outer-div">

  <!-- ================= PAGE HEADER ================= -->
  <div class="label-bar">
    <label class="textColour page-title">
      Actions
    </label>

    <span class="example-spacer"></span>

    <div class="header-actions">
      <app-common-button
            
          title="Refresh"
          icon="fas fa-sync-alt"
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="refreshData()"
          >
      </app-common-button>
      <app-common-button
        title="download"
        icon="fas fa-download"
        [buttonId]="1111"
        [variant]="'cancel'"
        width="100%"
        padding="0rem 1rem"
        fontSize=".85rem"
        height="25px"
        (clicked)="onDownload()">
      </app-common-button>

      <app-common-button
        label="Create"
        title="Create Actions"
        icon="fas fa-plus-circle"
        [buttonId]="1111"
        [variant]="'cancel'"
        width="100%"
        padding="0rem 1rem"
        fontSize=".85rem"
        height="25px"
        (clicked)="onCreate()">
      </app-common-button>
    </div>
  </div>

  <!-- ================= SUMMARY CARDS ================= -->
  <div class="summary-row">
   

    <div class="summary-card">
      <span class="label">Open</span>
      <span class="value">{{ openCount }}</span>
    </div>
<div class="summary-card">
      <span class="label">Overdue</span>
      <span class="value">{{ overdueCount }}</span>
    </div>
    <div class="summary-card">
      <span class="label">Completed</span>
      <span class="value">{{ completedCount }}</span>
    </div>

    
     <div class="summary-card">
      <span class="label">Total Actions</span>
      <span class="value">{{ totalActions }}</span>
    </div>
  </div>

  <!-- ================= TABS ================= -->
  <div class="actions-tabs">
    <div
      class="tab-item"
      [class.active]="selectedTab === 'MY'"
      (click)="selectTab('MY')">
      <i class="fas fa-tasks"></i>
      <span>My Actions</span>
      <span class="tab-badge">{{ myActionsCount }}</span>
    </div>

    <div
      class="tab-item"
      [class.active]="selectedTab === 'TEAM'"
      (click)="selectTab('TEAM')">
      <i class="fas fa-users"></i>
      <span>Team Actions</span>
    </div>

    <div
      class="tab-item"
      [class.active]="selectedTab === 'CALENDAR'"
      (click)="selectTab('CALENDAR')">
      <i class="fas fa-calendar-alt"></i>
      <span>Calendar</span>
    </div>
  </div>

  <!-- ================= TAB CONTENT ================= -->

  <!-- MY ACTIONS TAB -->
  <div *ngIf="selectedTab === 'MY'">
    <ag-grid-angular
      style="height: 45vh; width: 100%;"
      class="ag-theme-balham"
      [rowData]="mydata"
      [defaultColDef]="defaultColDef"
      [columnDefs]="myColumnDefs"
      [gridOptions]="gridOptions"
      [pagination]="true"
      [paginationPageSize]="10"
      [enableBrowserTooltips]="true"
      [components]="components"
      [rowClassRules]="rowClassRules"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>

  <!-- TEAM ACTIONS TAB -->
  <div *ngIf="selectedTab === 'TEAM'">
    <ag-grid-angular
      style="height: 45vh; width: 100%;"
      class="ag-theme-balham"
      [rowData]="teamsData"
      [defaultColDef]="defaultColDef"
      [columnDefs]="teamColumnDefs"
      [gridOptions]="gridOptions"
      [pagination]="true"
      [paginationPageSize]="10"
      [enableBrowserTooltips]="true"
      [components]="components"
      [rowClassRules]="rowClassRules"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>

  <!-- CALENDAR TAB -->
  <div *ngIf="selectedTab === 'CALENDAR'" class="calendar-container">
    <app-action-calendar
      [events]="calendarEvents">
    </app-action-calendar>

    <!-- Upcoming Deadlines This Month -->
    <!-- <div class="upcoming-deadlines">
      <h3>Upcoming Deadlines This Month - {{ currentMonthName }} {{ currentYear }}</h3>
      
      <div *ngFor="let event of upcomingDeadlinesThisMonth" class="deadline-row">
        <div class="deadline-date">
          {{ event.date | date:'MMM dd, yyyy' }}
        </div>

        <div class="deadline-desc">
          {{ event.description }}
        </div>

        <div class="priority-tag"
             [ngClass]="'priority-' + event.priority.toLowerCase()">
          {{ event.priority | titlecase }}
        </div>

        <div class="status-tag"
             [ngClass]="formatStatusClass(event.status)">
          {{ event.status }}
        </div>
      </div>
      
      <div *ngIf="upcomingDeadlinesThisMonth.length === 0" class="no-deadlines">
        No deadlines this month
      </div>
    </div> -->
  </div>

</div>